export const ISO_FILE_MANAGEMENT_CONSTANTS = {
  LIST_OF_ISO_FILES: "List of ISO Files",
  ISO_FILE_NAME: "ISO File Name",
  WELCOME_TO_ISO_FILE_MANAGEMENT: "Welcome to ISO File Management",
  DELETE_SELECTED: "Delete Selected",
  UPLOAD_ISO_FILE: "Upload ISO file",
  DELETE_ISO_FILE: "Delete ISO File",
  CANCEL: "Cancel",
  DONE: "Done",
  OK: "Ok",
  DELETE_MULTIPLE_ISOS: "Deleting Multiple ISOs",
  FILE_CANNOT_DELETE_DESCRIPTION:
    "Do you want to delete below ISO files. This action cannot be undone once deleted.",
  DELETE_ACTIVE_ISO: "Delete active ISO",
  DELETE_ACTIVE_ISO_DESCRIPTION:
    "Please stop or complete the course instance before deleting the file.",
  COURSE_ACTIVE_DESCRIPTION:
    "is currently in use by an active course instance.",
  FILE_DELETE_ISO_FILE: "Delete  ISO File",
  DELETE_ANYWAY: "Delete Anyway",
  DELETE_DESCRIPTION: "Are you sure you want to delete the following",
  ISO_FILE: "ISO file",
  LIST_OF_ISOS: "List of ISOs",
  UPLOAD_ISO_FILES: "Upload ISO File",
  SEARCH_THE_NAME: "Search the name",
  TOTAL_UPLOAD_SIZE_CANNOT_EXCEED: "Total upload size cannot exceed 15 GB.",
  FILES_PERMITTED:"Only ISO files are permitted.",
  MAX_FILE_NAME:"File name cannot exceed 128 characters.",
  UPLOAD:"UPLOAD"

};
